import React, { useState } from "react";
import SideBar from "./Sidebar";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Outlet } from "react-router-dom";

const Layout = () => {
  const [isSidebarClosed, setIsSidebarClosed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarClosed(prevState => !prevState);
  };

  const sizes = isSidebarClosed ? {
    sidebar: { xs: 2, sm: 2, md: 2, lg: 1 },
    main: { xs: 10, sm: 10, md: 10, lg: 11 }
  } : {
    sidebar: { xs: 7, sm: 5, md: 4, lg: 2 },
    main: { xs: 5, sm: 7, md: 8, lg: 10 }
  }

return (
  <Container fluid>
    <SideBar isSidebarClosed={isSidebarClosed} toggleSidebar={toggleSidebar}/>
    <Col
      className="p-5"
      xs={{ span: sizes.main.xs, offset: sizes.sidebar.xs }}
      sm={{ span: sizes.main.sm, offset: sizes.sidebar.sm }}
      md={{ span: sizes.main.md, offset: sizes.sidebar.md }}
      lg={{ span: sizes.main.lg, offset: sizes.sidebar.lg }}>
      <div className="w-100 h-100 main-content">
        <main className="w-100 h-100 App">
          <Outlet/>
        </main>
      </div>
    </Col>
  </Container>
);
}
;

export default Layout;
